import { useQuery } from '@tanstack/react-query';
import { getLineItems } from 'utils/OrderWebAPIUtils';
import { filterCanceledShipmentLineItems } from '../utils/filterCanceledShipmentLineItems';
export function useOrderRTBLineItems(orderId, tab, options = {}) {
    return useQuery(['order-rtb-lines', orderId, tab], async () => {
        var _a, _b;
        if (!orderId)
            return [];
        const type = tab === 'ar' ? 'receivables' : 'payables';
        const response = await getLineItems(orderId, {
            line_item_type: type,
            per_page: 100,
            page: 1,
        });
        const items = (_b = (_a = response === null || response === void 0 ? void 0 : response.entity) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : [];
        return filterCanceledShipmentLineItems(items);
    }, {
        enabled: options.enabled === undefined
            ? Boolean(orderId)
            : Boolean(options.enabled) && Boolean(orderId),
        staleTime: 30000,
    });
}
export function useOrderRTBArLineItems(orderId, options = {}) {
    return useOrderRTBLineItems(orderId, 'ar', options);
}
export function useOrderRTBApLineItems(orderId, options = {}) {
    return useOrderRTBLineItems(orderId, 'ap', options);
}
